import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import OrderList from './OrderList.vue';
import PlatformList from './PlatformList.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TheList',
  setup(__props) {

const loading = ref<boolean>(false);
const listType = ref<'normal' | 'points'>('points');


return { __sfc: true,loading, listType, OrderList, PlatformList }
}

})